export function formatPhone(str = '') {
  if (!str) {
    return str;
  }
  return `${str}`.slice(0, 3) + '****' + `${str}`.slice(7);
}
